import React, { Component } from 'react';
import './aside.scss';
import {
    Input,
    Form,
    FormGroup,
    Card,
    CardBody,
    Row,
    Col,
    Button
} from 'reactstrap';
import { connect } from 'react-redux'
import * as constant from '../../constants';
import MyAutosuggest from '../../components/ReusableComponents/AutoSuggest/index';
import { getCounterpartyType, getZone, getPortfolioCount } from '../../Analyst/Cases/Create/actions'
import { setPageView } from '../../components/GoogleAnalytics/index';
import _ from "lodash";
import * as corporateAction from '../../Corporate/corporate/action';
import * as homeAction from './action'

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            showCasesLegend: true,
            showCriticalLegend: false,
            showCorrespondentsLegend: false,
            ShowError: false,
            dropdownText: "",
            adminDashBoardData: {},
            selectedChart: "caseOverviewResponse",
            tableDataList: [],
            correspondentLoad: [],
            selectedCountryName: "India",
            selectedCountryCode: "IN",
            reportCategoryCount: undefined,
            selected: "Name"
        };
    }

    componentDidMount = () => {
        setPageView('/Home', document.location.href);
        this.props.getPortfolioCount();
    }

    componentDidUpdate(prevProps) {
        let updatedStateObject = {}
        if (this.props.searchText !== prevProps.searchText) {
            updatedStateObject.value = this.props.searchText
        }
        if (this.props.searchParam !== prevProps.searchParam) {
            updatedStateObject.selected = this.props.searchParam
        }
        if (this.props.portfolioCount !== prevProps.portfolioCount){
            this.preferredOrder(this.props.portfolioCount, [
                "INVESTIGATED_REPORT",
                "SUBSCRIPTION_REPORT",
                "KYC_REPORT",
                "OTHERS"
            ]);
        }
    }

    handleGlobalSearch = (e) => {
        if (e.key === constant.ENTER) {
            e.preventDefault()
            this.handleSearchData(this.state.selected, e.target.value, this.state.selectedCountryCode, this.state.selectedCountryName);
            this.props.setsearchParam(this.state.selected);
            this.props.setsearchText(e.target.value);
            this.props.setCountryName(this.state.selectedCountryName);
            this.props.setCountryCode(this.state.selectedCountryCode);
            this.props.setGlobalSearchBoxShow(true);
        }
    }
    handleSearchData = (searchParam, searchText, counteryCode, counteryName) => {
        this.setState(prevState => ({
            showSearchResults: !prevState.showSearchResults,
            searchText: searchText
        }));
        if (searchText) {
            let url = new URLSearchParams();
            url.set('s', searchText)
            url.set('country', counteryName)
            url.set('countryCode', counteryCode)
            this.props.history.push(`/search-result/${searchParam}?${url}`)
        }

    }
    handleSelect = (e, param) => {
        e.preventDefault();
        this.setState({
            selected: param, dropdownOpen: false
        })
    }
    handleChange = (e) => {
        this.setState({ value: e.target.value })

    }


    handleCloseInput = () => {
        if (window.innerWidth <= 800) {
            if (this.state.showSearchBox) {
                this.setState({
                    class: "form-search d-none", showSearchBox: false
                })
            }
        }
    }

    toggleSearchDD = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    searchCallback = (selected, type) => {
        this.setState({
            selectedCountryName: selected.value, selectedCountryCode: selected.id
        })
    }

    preferredOrder = (obj, order) => {
        var newObject = {};
        for(var i = 0; i < order.length; i++) {
            if(obj.hasOwnProperty(order[i])) {
                newObject[order[i]] = obj[order[i]];
            }
        }
        
        this.setState({
            reportCategoryCount: this.objMapper(newObject)
        })
    }

    objMapper = (obj) => {
        let newObj = _.mapKeys(obj, (value, key) => {
           switch (key) {
              case "INVESTIGATED_REPORT":
                 return "Premium Business Check";
              case "SUBSCRIPTION_REPORT":
                 return "Business Profile Report";
              case "KYC_REPORT":
                 return "KYC Report";
              case "OTHERS":
                 return "Other Reports";
              default:
                 return;
             }
           });
        return newObj;
    };

    redirectToPortfolio = (event, tabName) => {
        this.props.redirectToPortfolio(tabName);
        this.props.history.push("/my-portfolio/1");
    };

    render() {
        const { value } = this.state;
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            className: "form-control"
        };
        let searchDropDown;
        if (this.state.selectedCountryCode === constant.INDIA_COUNTRY_CODE) {
            searchDropDown = <ul className={this.state.dropdownOpen ? "dropdown-menu global-search-dd-menu d-block w-100" : "dropdown-menu d-none w-100"}><li className="py-2 px-3"><a onClick={(e) => this.handleSelect(e, "Name")} className="global-search-dd-menu-item" href="">Name</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "GST")} className="global-search-dd-menu-item" href="">GST</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "PAN")} className="global-search-dd-menu-item" href="">PAN</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "CIN")} className="global-search-dd-menu-item" href="">CIN</a></li></ul>
        } else {
            searchDropDown = <ul className={this.state.dropdownOpen ? "dropdown-menu global-search-dd-menu d-block w-100" : "dropdown-menu d-none w-100"}><li className="py-2 px-3"><a onClick={(e) => this.handleSelect(e, "Name")} className="global-search-dd-menu-item" href="">Name</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "GST")} className="global-search-dd-menu-item" href="">GST</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "PAN")} className="global-search-dd-menu-item" href="">PAN</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "CIN")} className="global-search-dd-menu-item" href="">CIN</a></li></ul>
        }
        return (
            <Col sm="24" className='homeContainer'>
                <Row>
                    <Col>
                        <Card className='align-items-center'>
                            <CardBody className="text center searchBox">
                                <Row>
                                    <Col sm={8}>
                                        <MyAutosuggest
                                        {...this.props}
                                            id='countrySearch'
                                            placeholder="Search Country"
                                            onChange={this.handleCountryAutocomplete}
                                            searchCallback={this.searchCallback}
                                            inputProps={inputProps}
                                            searchType="countrySearch"
                                            selectedValueCountry={this.state.selectedCountry} />
                                    </Col>
                                    <Col sm={16}>
                                        <Form className={this.state.class}>
                                            <FormGroup className="mb-0 position-relative input-search w-100">
                                                <i className="icon-search position-absolute search-icon-color" style={{ '--primaryColor': this.props.corporateColor }}></i>
                                                <Input type="search" name="search" id="search" placeholder={"Search Counterparty by " + this.state.selected} value={this.state.value}
                                                    onChange={this.handleChange} onKeyPress={this.handleGlobalSearch} />
                                                <i onClick={this.toggleSearchDD} className="icon-arrow-down position-absolute"></i>
                                                {/*<i className="icon-close position-absolute d-sm-none" onClick={this.handleCloseInput}></i>*/}
                                                {searchDropDown}



                                            </FormGroup>
                                        </Form>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className='reportCountCard'>
                    {this.state.reportCategoryCount !== undefined && Object.keys(this.state.reportCategoryCount).map(item =>  <Card key={item}>
                        <CardBody className="text center">
                            <Button className="table-responsive table-bordered reportCountTable" onClick={(e)=> this.redirectToPortfolio(e, item)} style={{background: this.props.corporateColor.colorHexCode}}>
                                <table className="table reportCountTable">
                                    <tbody>
                                    <tr>
                                        <td valign='middle'><p className='reportCount'>{item && Object.values(this.state.reportCategoryCount)[Object.keys(this.state.reportCategoryCount).indexOf(item)]}</p></td>
                                    </tr>
                                     <tr>
                                        <td valign='middle'><p className='reportCountText'>{item && item}</p></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </Button>
                        </CardBody> 
                    </Card>)} 
                </Row>
            </Col>
        );
    }
}



const mapStateToProps = (state, ownProps) => ({
    portfolioCount: state.createCase.portfolioCountData,
    searchText: state.corporate.searchText,
    countryName: state.corporate.countryName,
    searchParam: state.corporate.searchParam,
    globalSearchBoxShow: state.corporate.globalSearchBoxShow,
    corporateColor: state.corporate.corporateColor
});
const mapDispatchToProps = (dispatch) => ({
    getPortfolioCount: () => { dispatch(getPortfolioCount()) },
    setsearchParam: (searchParam) => { dispatch(corporateAction.searchParameter(searchParam)) },
    setsearchText: (searchText) => { dispatch(corporateAction.searchText(searchText)) },
    setCountryName: (countryName) => { dispatch(corporateAction.countryName(countryName)) },
    setCountryCode: (countryCode) => { dispatch(corporateAction.countryCode(countryCode)) },
    setGlobalSearchBoxShow: (boolean) => {dispatch(corporateAction.setGlobalSearchBoxShow(boolean))},
    redirectToPortfolio: (data) => {dispatch(homeAction.redirectToPortfolio(data))}
});
export default connect(mapStateToProps, mapDispatchToProps)(Home);